import { cn } from "src/utils";
import { Spinner } from "../Spinner";
import styles from "./button.module.scss";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  loader?: boolean;
  design?: "orange" | "primary" | "secondary" | "tertiary" | "tertiary-outline";
  size?: "sm" | "md" | "lg";
  fontSize?: string;
  wrapperBtnClassName?: string;
}

const Button: React.FC<ButtonProps> = ({
  children,
  type,
  label,
  onClick,
  disabled,
  loader,
  design = "primary",
  size = "md",
  className,
  wrapperBtnClassName,
  fontSize,
  style,
  ...buttonProps
}) => {
  return (
    <button
      {...buttonProps}
      onClick={onClick}
      aria-label={label}
      type={type}
      className={cn(
        design === "primary" && styles["button"],
        design === "tertiary" && styles["button--tertiary"],
        design === "tertiary-outline" && styles["button--tertiary-outline"],
        design === "secondary" && styles["button--secondary"],
        design === "orange" && styles["button--orange"],
        size === "sm" && styles["button--sm"],
        size === "lg" && styles["button--lg"],
        wrapperBtnClassName && wrapperBtnClassName
      )}
      disabled={loader || disabled}
      style={style}
    >
      <span className={cn(fontSize && `text-${fontSize}`, className)}>
        {loader ? <Spinner /> : children}
      </span>
    </button>
  );
};

export default Button;
